import { authStore } from "@/store/auth"
import { useQuery } from "@tanstack/react-query"

import { authService } from "../services/authService"

export const userOrganizationsQueryKey = (userId: string | undefined) => [
  "auth",
  "user-organizations",
  userId,
]

export function useUserOrganizations() {
  const userId = authStore(state => state.user?.id)

  return useQuery({
    queryKey: userOrganizationsQueryKey(userId),
    queryFn: () => authService.getUserOrganizations(userId!),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
  })
}

export function useIsCrmScoped(): boolean {
  return authStore(state => state.user?.active_organization_scope === "crm")
}
